import React from 'react';
import { Box, Typography } from '@mui/material';
import { SettingsInput } from './SettingsPrimitives';
import { NODE_UI } from '../../../NodeUI/nodeUiStyles';

const COMMON_MIME_GROUPS = [
  { label: 'PDF', mimes: ['application/pdf'] },
  { label: 'Images', mimes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'] },
  { label: 'Word', mimes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'] },
  { label: 'Excel', mimes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] },
  { label: 'CSV', mimes: ['text/csv'] },
  { label: 'Video', mimes: ['video/mp4', 'video/webm', 'video/ogg'] },
  { label: 'Audio', mimes: ['audio/mpeg', 'audio/ogg', 'audio/wav'] },
  { label: 'ZIP', mimes: ['application/zip', 'application/x-zip-compressed'] },
];

export default function FileUploadSettings({ field, onUpdate, palette, theme }) {
  const upload = field.upload || {};
  const allowedMimes = upload.allowedMimeTypes || [];
  const maxFiles = upload.maxFiles || '';

  const updateUpload = (patch) => onUpdate({ upload: { ...upload, ...patch } });

  const isGroupSelected = (group) => group.mimes.every((m) => allowedMimes.includes(m));

  const toggleGroup = (group) => {
    const selected = isGroupSelected(group);
    let next;
    if (selected) {
      next = allowedMimes.filter((m) => !group.mimes.includes(m));
    } else {
      const toAdd = group.mimes.filter((m) => !allowedMimes.includes(m));
      next = [...allowedMimes, ...toAdd];
    }
    updateUpload({ allowedMimeTypes: next.length ? next : undefined });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <SettingsInput
        label="Max files"
        value={maxFiles}
        onChange={(v) => updateUpload({ maxFiles: v === '' ? undefined : v })}
        placeholder="Unlimited"
        type="number"
        palette={palette}
        theme={theme}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography sx={{ fontSize: NODE_UI.fontSize.caption, fontWeight: NODE_UI.fontWeight.label, color: palette.textSecondary, userSelect: 'none' }}>
          Allowed file types {allowedMimes.length === 0 && <Box component="span" sx={{ fontWeight: 400, opacity: 0.7 }}>(all types)</Box>}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', mt: '2px' }}>
          {COMMON_MIME_GROUPS.map((group) => {
            const active = isGroupSelected(group);
            return (
              <Box
                key={group.label}
                onClick={(e) => { e.stopPropagation(); toggleGroup(group); }}
                sx={{
                  px: '8px',
                  py: '3px',
                  borderRadius: NODE_UI.borderRadiusSm,
                  border: `1px solid ${active ? palette.textSecondary : palette.border}`,
                  backgroundColor: active ? palette.surface : 'transparent',
                  cursor: 'pointer',
                  userSelect: 'none',
                  transition: 'all 0.12s ease',
                  '&:hover': { borderColor: palette.textSecondary },
                }}
              >
                <Typography sx={{ fontSize: '11px', fontWeight: active ? 600 : 400, color: active ? palette.textPrimary : palette.textSecondary }}>
                  {group.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
